import { useLocation } from 'react-router-dom';

/**
 * Given this url:
 * http://localhost:5173/docs/reference/payouts#payouts-create?product_id=394
 *
 * Outputs this
 * 394
 *
 ** Given this url:
 * http://localhost:5173/docs/reference/payouts#payouts-create
 *
 * Outputs this
 * undefined

 *
 */
export function useProductIdFromUrl() {
  const location = useLocation();
  const productId = location.hash.split('?')?.[1]?.split('=')?.[1];
  return productId ? Number(productId) : undefined;
}
